import { InstallmentConstant } from '../constants';
import { RequestAction } from '.';

export const getInstallments = params =>
  RequestAction.request(InstallmentConstant.GET_INSTALLMENTS, {
    params,
    url: '/api/installment',
  }, false);

export const setInstallments = payload => ({
  payload,
  type: InstallmentConstant.SET_INSTALLMENTS,
});
